import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { colorGrid } from 's2s-themes';
import styled from 'styled-components';
import { RightArrowIconSVG } from 's2s-svg-navigation';
import { getIntlText } from '../js/utilities';
import Input from 's2s-input';
import { injectIntl } from 'react-intl';
import { LocalStorageService } from 's2s-app-service';

// Styles the Container
const UserNameContainer = styled.div`
    background: ${colorGrid.gray1};
    border-radius: 8px;
    box-shadow: 0px 4px 8px rgba(33, 37, 41, 0.4);
    padding : 8px 0px;
    margin: 0 auto;
    width: 100%;
    max-width: 344px;
     @media(max-width: 376px) {
     width: 90%;
    }
`;


const StyledInput = styled(Input)`
  width: calc(100% - 48px);
  margin: 16px auto;
`;

const NextButton = styled.button`
  align-items : center;
  background: ${colorGrid.brand5};
  border : 1px solid transparent;
  border-radius: 4px;
  color: ${colorGrid.gray0};
  display : flex;
  /* font-size: 14px; */
  line-height: 24px;
  margin-left: 24px;
  margin-top : 24px;
  padding : 8px 16px;
  text-align: center;
  outline : none;
  text-transform : uppercase;

  &:hover {
    background: ${colorGrid.brand7};
    cursor : pointer;
  }

  &:focus { 
      outline : ${colorGrid.blue5};
      /* box shadow exists on all s2s form elements is necessary to indicate active state and override default browser settings. Color value is a colorGrid value in rgba format with .6 opacity */
      -webkit-box-shadow: 0px 0px 0px 2px rgba(34,138,230,0.6);
      -moz-box-shadow: 0px 0px 0px 2px rgba(34,138,230,0.6);
      box-shadow: 0px 0px 0px 2px rgba(34,138,230,0.6);
  }

  &:active {
    outline : none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow : none;
  }

`;

const UserName = (props) => {

  const [userNameValue, setUserNameValue] = useState("");
  const buttonRef = useRef(null);

  useEffect(() => {
    if (LocalStorageService.getData('lastUser').data &&
      LocalStorageService.getData('lastUser').data.username) {
      setUserNameValue(LocalStorageService.getData('lastUser').data.username);
      LocalStorageService.deleteData('lastUser');
    }
  }, []);

  // Normally, if a user hits enter focus is still left on input. However,
  // this prevents users from seeing the error. Therefore, we put focus on
  // the SIGN IN button to get error message to display.
  const focusButton = () => {
    ReactDOM.findDOMNode(buttonRef.current).focus();
  };

  const handleInputChange = (inputValue) => {
    setUserNameValue(inputValue);
  };

  const handleClick = () => {
    props.cbNext(userNameValue);
  };

  const handleEnter = () => {
    focusButton();
    props.cbOnEnter(userNameValue);
  };

  return (
    <UserNameContainer className="UserNameContainer">
      <StyledInput className="userInput"
        autoFocus
        value={userNameValue}
        cbOnChange={handleInputChange}
        cbOnEnter={handleEnter}
        cbOnFocus={props.cbOnFocus}
        errorText={getIntlText(props.intl, 'USERNAME-INPUT-ERROR-TEXT', "Enter a valid user login to continue")}
        hasError={props.hasError}
        inputLabel={getIntlText(props.intl, 'USERNAME-INPUT-LABEL-TEXT', "Enter user login")}
        svgType="AvatarIconSVG"
        placeholder={getIntlText(props.intl, 'USERNAME-INPUT-PLACEHOLDER-TEXT', "Enter username or email...")}
      />
      <NextButton
        className="NextButton"
        onClick={handleClick}
        ref={buttonRef}
      >
        {getIntlText(props.intl, 'USERNAME-NEXT-BUTTON-TEXT', 'Next')}
        <RightArrowIconSVG
          svgStyle={{
            fill: colorGrid.gray0,
            height: '24px',
            width: '24px'
          }}
        />
      </NextButton>
    </UserNameContainer>
  );
};


UserName.propTypes = {
  cbNext: PropTypes.func,
  cbOnFocus: PropTypes.func,
  cbOnEnter: PropTypes.func,
  hasError: PropTypes.bool,
  intl: PropTypes.object,
};


UserName.defaultProps = {
  cbNext: () => { console.log('cbNext default func fired'); },
  cbOnFocus: () => { },
  hasError: false
};

export default injectIntl(UserName);
